export function formatSearchResultPath(objectType: string, objectCategory?: string | null, objectSubCategory?: string | null): string {
  return [objectType, objectCategory || null, objectSubCategory || null].filter(Boolean).join(' / ');
}
